var _Path, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgDefault = function SvgDefault(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#default_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M27.89 3C14.166 3 3 14.157 3 27.872c0 5.719 1.974 11.261 5.573 15.684a14.9 14.9 0 0 1-5.002 6.492 1.156 1.156 0 0 0 .316 2.024A17.3 17.3 0 0 0 9.472 53c3.021 0 5.973-.786 8.578-2.277a24.7 24.7 0 0 0 9.84 2.021c13.724 0 24.89-11.157 24.89-24.872S41.614 3 27.89 3m0 47.43c-3.291 0-6.465-.693-9.434-2.06a1.16 1.16 0 0 0-1.096.069 14.9 14.9 0 0 1-7.888 2.247 15 15 0 0 1-2.776-.26 17.2 17.2 0 0 0 4.29-6.717c.135-.39.053-.822-.216-1.135a22.54 22.54 0 0 1-5.455-14.702c0-12.439 10.127-22.558 22.575-22.558s22.574 10.12 22.574 22.558S40.337 50.43 27.89 50.43"
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M27.89 3C14.166 3 3 14.157 3 27.872c0 5.719 1.974 11.261 5.573 15.684a14.9 14.9 0 0 1-5.002 6.492 1.156 1.156 0 0 0 .316 2.024A17.3 17.3 0 0 0 9.472 53c3.021 0 5.973-.786 8.578-2.277a24.7 24.7 0 0 0 9.84 2.021c13.724 0 24.89-11.157 24.89-24.872S41.614 3 27.89 3m0 47.43c-3.291 0-6.465-.693-9.434-2.06a1.16 1.16 0 0 0-1.096.069 14.9 14.9 0 0 1-7.888 2.247 15 15 0 0 1-2.776-.26 17.2 17.2 0 0 0 4.29-6.717c.135-.39.053-.822-.216-1.135a22.54 22.54 0 0 1-5.455-14.702c0-12.439 10.127-22.558 22.575-22.558s22.574 10.12 22.574 22.558S40.337 50.43 27.89 50.43"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "M29.49 19.305v7.206h7.206a1.49 1.49 0 0 1 0 2.979H29.49v7.206a1.49 1.49 0 0 1-2.98 0V29.49h-7.206a1.49 1.49 0 0 1 0-2.98h7.207v-7.205a1.49 1.49 0 1 1 2.979 0",
    clipRule: "evenodd"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "default_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M3 3h50v50H3z"
  })))));
};
export default SvgDefault;